// extracted by mini-css-extract-plugin
export var noResultsContainer = "SearchResultsBox-module--no-Results-Container--861dd";
export var searchItem = "SearchResultsBox-module--search-item--a61d0";
export var searchItemsContainer = "SearchResultsBox-module--search-items-container--2e252";
export var searchLoadingContainer = "SearchResultsBox-module--search-Loading-Container--dd515";
export var suggestedheader = "SearchResultsBox-module--suggestedheader--0d64b";